import { createI18nText } from '@hilma/netina2all';

const topbarText = createI18nText({
	he: {
		home: 'בית',
		howItWorks: 'איך זה עובד',
		distStations: 'תחנות חלוקה',
		associations: 'העמותות',
		prices: 'מחירון',
		whoWeAre: 'מי אנחנו',
		commonQs: 'שאלות נפוצות',
		contact: 'צור קשר',
		profile: 'אזור אישי',

		otherLang: 'English',
		buy: 'לרכישה'
	},
	en: {
		home: 'Home',
		howItWorks: 'How it Works',
		distStations: 'Distribution Stations',
		associations: 'Associations',
		prices: 'Prices',
		whoWeAre: 'Who We Are',
		commonQs: 'Common Questions',
		contact: 'Contact Us',
		profile: 'My Profile',

		otherLang: 'עברית',
		buy: 'Purchase'
	}
});

export default topbarText;